export const WELCOME_TEXT_TYPE_ID = 'welcome';
export const OVERVIEW_TEXT_TYPE_ID = 'overview';
